import red from '@material-ui/core/colors/red';

export default {
  weekEndCell: '#0EFF0028',
  shortDayCell: '#FEF1D680',
  holidayCell: '#FEE8BA80',
  confirmedCell: '#c0c0c0',
  weekEndHeaderCell: '#4caf50',
  shortDayHeaderCell: '#FDD580',
  holidayHeaderCell: '#FCB92E',
  newUserCircle: '#93d296',
  paleBlue: '#6d8089',
  error: {
    main: red[500],
    custom: '#cd3e41',
    required: '#888888'
  },
  subheaderBorderColor: '#d3d3d3'
};
